import React from "react";
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import { Fragment } from "react";
import Loader from 'react-loader-spinner'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Papa from 'papaparse';

import {
	Card,
	CardBody,
	Col,
	Row,
	Input,
	Button,
	ButtonGroup,
	Fade
} from 'reactstrap';

import 'react-table-v6/react-table.css'
import {
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA
} from '../../dashboard/product-filter';
import {
	buildShipmentDateRows,
	getShipmentDateRequestBody,
	validateShipmentDateHeaders
} from './batch-shipment-date-helpers';

import csvPlaceholder from '../../../assets/images/csv-icon512x512.png';

class BatchShipmentDateUpload extends React.Component {

	constructor(props) {
    super(props);

    this.state = {
			errorMsg: null,
			isUploadingFile: false,
			isSavingDates: false,
			loadedSerialBatch: false,
			selectedFileSerialBatch: null,
			parsedCSVData: [],
			productType: PRODUCT_TYPE_EVO,
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
	  };

  }

	onClickUploadSerialBatchHandler = () => {

		const file = this.state.selectedFileSerialBatch;

    if (!file) {
			this.setState({ errorMsg: 'Please select a CSV file.' });
      //setErrorMsg('Please select a CSV file.');
      return;
    }

		this.setState({ isUploadingFile: true, errorMsg: null });

		Papa.parse(file, {
			header: true,
			dynamicTyping: false,
			skipEmptyLines: true,
			complete: (result) => {
				if (result.errors.length > 0) {
					this.setState({
						errorMsg: 'Error parsing the CSV file.',
						parsedCSVData: [],
						isUploadingFile: false
					});
				} else {
					const missingHeaders = validateShipmentDateHeaders(result.meta && result.meta.fields);

					if (missingHeaders.length > 0) {
						this.setState({
							errorMsg: `CSV is missing required column${missingHeaders.length > 1 ? 's' : ''}: ${missingHeaders.join(', ')}.`,
							parsedCSVData: [],
							isUploadingFile: false
						});
						return;
					}

					const formattedCSVData = buildShipmentDateRows(result.data, this.state.productType);
					const invalidRowCount = formattedCSVData.filter(row => !row.IsValid).length;

					this.setState({
						parsedCSVData: formattedCSVData,
						errorMsg: invalidRowCount > 0
							? `${invalidRowCount} row${invalidRowCount === 1 ? '' : 's'} must be corrected before saving.`
							: null,
						isUploadingFile: false
					});

				}
			},
			error: () => {
				this.setState({
					errorMsg: 'Error parsing the CSV file.',
					parsedCSVData: [],
					isUploadingFile: false
				});
			}
		});

	}

	onChangeSerialBatchHandler = (event) => {
		const selectedFile = event.target.files && event.target.files[0];

		if (!selectedFile) {
			this.setState({
				selectedFileSerialBatch: null,
				loadedSerialBatch: false,
				parsedCSVData: [],
				errorMsg: null
			});
			return;
		}

		this.setState({
			selectedFileSerialBatch: selectedFile,
			loadedSerialBatch: true,
			parsedCSVData: [],
			errorMsg: null
		})
	}

	selectProductType = productType => {
		if (this.state.isSavingDates || this.state.isUploadingFile) return;
		if (parseInt(productType) === parseInt(this.state.productType)) return;

		const fileInput = document.getElementById('fileSerialBatch');
		if (fileInput) fileInput.value = null;

		this.setState({
			productType,
			selectedFileSerialBatch: null,
			loadedSerialBatch: false,
			parsedCSVData: [],
			errorMsg: null
		});
	}

	filterCaseInsensitive = (filter, row) => {
		const rowValue = row[filter.pivotId || filter.id];
		return rowValue !== undefined && rowValue !== null
			? String(rowValue).toLowerCase().indexOf(String(filter.value).toLowerCase()) !== -1
			: false;
	}

	saveShipmentDatesData = async () => {
		if (this.state.parsedCSVData.length === 0 || this.state.parsedCSVData.some(row => !row.IsValid)) {
			this.setState({ errorMsg: 'Correct all CSV errors before saving.' });
			return;
		}

		this.setState({ isSavingDates: true });

    var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"save-batch-shipment-dates";

		const requestBody = getShipmentDateRequestBody(this.state.parsedCSVData, this.state.productType);

		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					Authorization: this.state.currentUser.jwtToken,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(requestBody)
			});

			const body = await response.json();

			if (response.ok && body.status === 'Success') {
			//this.setState({ productsData: body.response });
			this.setState({ parsedCSVData: [] });
			const fileInput = document.getElementById("fileSerialBatch");
			if (fileInput) fileInput.value = null;
			this.setState({ selectedFileSerialBatch: null, loadedSerialBatch: false });
			this.setState({ isSavingDates: false });
			toast.success(`${requestBody.ShipmentDatesList.length} ${this.state.productType === PRODUCT_TYPE_NOVA ? 'Nova' : 'EVO'} shipment date${requestBody.ShipmentDatesList.length === 1 ? '' : 's'} successfully uploaded.`, {
				position: "top-center",
				autoClose: 3000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "dark",
				closeButton: false
			});

			} else {
				throw new Error(body && (body.response || body.error) ? body.response || body.error : 'Upload failed');
			}
		} catch (error) {
			this.setState({ isSavingDates: false });
			toast.error(error && error.message ? error.message : "Error uploading device shipment dates. Please try again.", {
				position: "top-center",
				autoClose: 3000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "dark",
				closeButton: false
			});
		}

	};

		render() {
		const hasInvalidRows = this.state.parsedCSVData.some(row => !row.IsValid);
		const selectedProductName = this.state.productType === PRODUCT_TYPE_NOVA ? 'Nova' : 'EVO';

		const data = this.state.parsedCSVData.map((prop, key) => {

			return {
				id: key,
				SerialNumber: prop.SerialNumber,
				InvoiceDate: prop.InvoiceDate,
				Product: selectedProductName,
				Status: prop.Status,
				IsValid: prop.IsValid
			};
		});

		return (
      <Fragment>
        <Card className="card-hover">
          <CardBody>
            <Row className="mb-3">
              <Col md="12">
                <h3 style={{color:'#737782'}}>Batch Shipment Date Upload</h3>
              </Col>
            </Row>
						<Row className="mb-3">
							<Col xs="12" sm="6" md="4" lg="3">
								<ButtonGroup style={{ width: '100%' }} aria-label="Shipment date product">
									<Button
										style={{width: '100%'}}
										size="sm"
										color="btngray"
										active={this.state.productType === PRODUCT_TYPE_EVO}
										aria-pressed={this.state.productType === PRODUCT_TYPE_EVO}
										disabled={this.state.isSavingDates || this.state.isUploadingFile}
										onClick={() => this.selectProductType(PRODUCT_TYPE_EVO)}
									>
										EVO
									</Button>
									<Button
										className="ml-1"
										style={{width: '100%'}}
										size="sm"
										color="btngray"
										active={this.state.productType === PRODUCT_TYPE_NOVA}
										aria-pressed={this.state.productType === PRODUCT_TYPE_NOVA}
										disabled={this.state.isSavingDates || this.state.isUploadingFile}
										onClick={() => this.selectProductType(PRODUCT_TYPE_NOVA)}
									>
										Nova
									</Button>
								</ButtonGroup>
							</Col>
						</Row>
						{!this.state.isUploadingFile ? (
							<Fragment>
							<Row className="align-items-center">
								<Col xs="12" md="5" lg="4">
									<Input className="" type="file" name="fileSerialBatch" id="fileSerialBatch" accept=".csv" disabled={this.state.isSavingDates || this.state.isUploadingFile} onChange={this.onChangeSerialBatchHandler} onClick={e => (e.target.value = null)}/>
								</Col>
								<Col xs="12" md="3" lg="3" className="mt-2 mt-md-0">
									{this.state.loadedSerialBatch &&
										<Fragment>
											<Button className="" size="sm" color="yellow" title="Upload" disabled={this.state.isUploadingFile || this.state.isSavingDates} onClick={this.onClickUploadSerialBatchHandler}>
												Upload
											</Button>
											<img style={{ marginTop: "-3px"}} className="ml-2" src={csvPlaceholder} width="30" alt="Selected CSV file"/>
										</Fragment>
									}
								</Col>
								<Col xs="12" md="4" lg="5" className="mt-2 mt-md-0">
								{!this.state.isSavingDates ? (
									<Fragment>
										{this.state.parsedCSVData.length > 0 &&
										<Button className="float-right" size="" color="yellow" title="Upload" disabled={hasInvalidRows} onClick={this.saveShipmentDatesData}>
											Save Shipment Dates
											</Button>
										}
									</Fragment>
								) : (
									<Fragment>
										<Row className="pl-4 float-right">
												<Fade in="true">
													<Row className="justify-content-center">
														<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
													</Row>
												</Fade>
										</Row>
									</Fragment>
								)}
								</Col>
							</Row>
							<Row className="pt-3">
								<Col xs="12" md="8" lg="8">
									{this.state.errorMsg && <p className="error">{this.state.errorMsg}</p>}
								</Col>
							</Row>
							</Fragment>
						) : (
							<Row className="pl-4 pl-4">
									<Fade in="true">
										<Row className="justify-content-center">
											<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
										</Row>
									</Fade>
							</Row>
						)}
          </CardBody>


        </Card>
				<Card className="card-hover">
          <CardBody>
						<div className="table-responsive">
						<ReactTable
							style={{backgroundColor:'#000', padding:'10px', minWidth: '700px', autocomplete: 'none'}}
							columns={[
								{
									Header: "Product",
									accessor: "Product",
									width: 110,
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									Cell: row => (
										<div style={{ textAlign: "center" }}>{row.value}</div>
									)
								},
								{
									Header: "Serial Number",
									accessor: "SerialNumber",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									Cell: row => (
											<div style={{ textAlign: "center" }}>{row.value}</div>
										)
								},
								{
									Header: "Invoice Date",
									accessor: "InvoiceDate",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									Cell: row => (
											<div style={{ textAlign: "center" }}>{Moment(row.value).format('MM/DD/YYYY')}</div>
										)
								},
								{
									Header: "Status",
									accessor: "Status",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									Cell: row => (
										<div style={{ color: row.original.IsValid ? '#5cb85c' : '#dc3545', textAlign: "center", whiteSpace: 'normal', overflowWrap: 'break-word' }}>{row.value}</div>
									)
								},
							]}
							defaultPageSize={15}
							sortable={true}
							showPaginationBottom={true}
							className="-striped -highlight"
							data={data}
							filterable
							filterAll={true}
							defaultFilterMethod={(filter, row) => this.filterCaseInsensitive(filter, row) }
							getTrGroupProps={(state, rowInfo, column, instance) => {
											if (rowInfo !== undefined) {
													return {
															onClick: (e, handleOriginal) => {
																//console.log('It was in this row:', rowInfo)
																//console.log('with ID:', rowInfo.original.categoryID);

																//this.goToRepairLog(rowInfo.original.repairId);
															}
													}
											}}
									}
						/>
						</div>
					</CardBody>
        </Card>
				<ToastContainer/>
      </Fragment>
		);
	}
}

export default BatchShipmentDateUpload;
